var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSaEnkeltLogoWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 140.471,
    height: 47.108,
    viewBox: "0 0 140.471 47.108",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    transform: "translate(-2.079 -18.43)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_1043",
    transform: "translate(2.079 29.748)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1079",
    "data-name": "Path 1079",
    d: "M9.626,58.72c5.206,0,7.847-3.521,7.847-10.488,0-5.533-1.534-8.325-6.363-11.393L9.2,35.556A5.506,5.506,0,0,1,6.231,30.35c0-2.641,1.534-4.4,3.823-4.4,2.415,0,3.6,1.434,3.6,4.4v.3a1.552,1.552,0,0,0,1.408,1.685h.176A1.5,1.5,0,0,0,16.82,30.9v-.578c0-4.829-2.389-7.394-6.866-7.394-4.2,0-7.017,2.968-7.017,7.369,0,3.722,1.333,6.036,4.754,8.25l1.937,1.283c3.4,2.213,4.552,4.376,4.552,8.627,0,4.829-1.434,7.193-4.4,7.193-2.666,0-4.4-2.138-4.4-5.458A9.616,9.616,0,0,1,6,46.849a2.1,2.1,0,0,0,0-1.61,1.206,1.206,0,0,0-.729-.629,1.88,1.88,0,0,0-2.364,1.107,12.324,12.324,0,0,0-.83,4.678c0,5.131,2.918,8.3,7.6,8.3h0Z",
    transform: "translate(-2.079 -22.93)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_1044",
    transform: "translate(40.94 29.823)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1080",
    "data-name": "Path 1080",
    d: "M28.546,52.94H23.164V41.647h4.628a2.755,2.755,0,0,0,.126-5.508H23.164V28.468h5.382a2.755,2.755,0,1,0,.126-5.508H21.454c-2.565,0-3.924,1.308-3.924,3.773V54.7c0,2.465,1.358,3.773,3.924,3.773h7.093a2.755,2.755,0,1,0,.126-5.508h-.126Z",
    transform: "translate(-17.53 -22.96)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_1045",
    transform: "translate(57.841 29.295)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1081",
    "data-name": "Path 1081",
    d: "M40.246,31.6c0-5.785-2.767-8.853-8-8.853s-8,3.043-8,8.853V55.9a2.857,2.857,0,0,0,5.709,0V31.7c0-2.415.729-3.521,2.264-3.521s2.264,1.132,2.264,3.521V55.9a2.857,2.857,0,0,0,5.709.226V31.578h0Z",
    transform: "translate(-24.25 -22.75)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_1046",
    transform: "translate(78.163 29.518)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1082",
    "data-name": "Path 1082",
    d: "M48.075,44.472c0-2.641-.7-4.276-2.264-5.156l-.277-.151.252-.2a5.193,5.193,0,0,0,1.886-4.552v-8.6a2.857,2.857,0,0,0-5.709-.226v7.8c0,2.113-.78,3.068-2.515,3.068H38.039V25.835a2.857,2.857,0,1,0-5.709-.226V55.84a2.857,2.857,0,0,0,5.709,0V41.655h1.61c1.66,0,2.716,1.358,2.716,3.471V55.84a2.857,2.857,0,0,0,5.709,0V44.522h0Z",
    transform: "translate(-32.33 -22.839)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_1047",
    transform: "translate(98.108 29.823)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1083",
    "data-name": "Path 1083",
    d: "M51.276,52.94H45.894V41.647h4.628a2.755,2.755,0,0,0,0-5.508H45.894V28.468h5.382A2.755,2.755,0,1,0,51.4,22.96H44.184c-2.565,0-3.924,1.308-3.924,3.773V54.7c0,2.465,1.358,3.773,3.924,3.773h7.093a2.755,2.755,0,1,0,.126-5.508h-.126Z",
    transform: "translate(-40.26 -22.96)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_1048",
    transform: "translate(115.186 29.495)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1084",
    "data-name": "Path 1084",
    d: "M56.934,53.138H52.759V25.8a2.857,2.857,0,1,0-5.709-.226V54.9c0,2.465,1.358,3.773,3.924,3.773H56.96a2.755,2.755,0,0,0,0-5.508h0Z",
    transform: "translate(-47.05 -22.829)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_1049",
    transform: "translate(126.579 29.823)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1085",
    "data-name": "Path 1085",
    d: "M64.759,22.96H54.4a2.755,2.755,0,0,0-.126,5.508h2.44V55.606a2.857,2.857,0,1,0,5.709.226V28.468h2.314a2.755,2.755,0,0,0,.126-5.508h-.126Z",
    transform: "translate(-51.58 -22.96)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_1050",
    transform: "translate(21.146 29.119)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1086",
    "data-name": "Path 1086",
    d: "M24.65,30.9c0-5.231-2.741-8.224-7.5-8.224s-7.5,2.993-7.5,8.224V57.414a1.685,1.685,0,0,0,3.37,0V45.895H21.3V57.414a1.685,1.685,0,0,0,3.37,0V30.9h0ZM21.28,42.826H13.005V31.558c0-3.873,1.358-5.734,4.125-5.734s4.125,1.886,4.125,5.734V42.8h0Z",
    transform: "translate(-9.66 -22.68)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_1051",
    transform: "translate(24.792 18.43)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1087",
    "data-name": "Path 1087",
    d: "M14.983,26.126h-.05a3.864,3.864,0,1,1,2.741-1.132,3.747,3.747,0,0,1-2.691,1.132Zm-.025-5.055a1.208,1.208,0,0,0-1.207,1.207,1.192,1.192,0,0,0,1.207,1.207,1.062,1.062,0,0,0,.83-.352,1.192,1.192,0,0,0-.855-2.037Z",
    transform: "translate(-11.11 -18.43)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaEnkeltLogoWhite);
export default __webpack_public_path__ + "static/media/sa-enkelt-logo-white.0f0c7daed6b25030f09725a60cca2051.svg";
export { ForwardRef as ReactComponent };